export var MetaTagRobotsOptions;
(function (MetaTagRobotsOptions) {
    MetaTagRobotsOptions["ALL"] = "all";
    MetaTagRobotsOptions["NO_INDEX"] = "noindex";
    MetaTagRobotsOptions["NO_FOLLOW"] = "nofollow";
    MetaTagRobotsOptions["NO_INDEX_NO_FOLLOW"] = "noindex, nofollow";
})(MetaTagRobotsOptions || (MetaTagRobotsOptions = {}));
//# sourceMappingURL=pageMeta.js.map